import getActionsByDocument from '../../../../components/comments/actions';

const DOCUMENT = 'JOB_COMMENTS_';

export default getActionsByDocument(DOCUMENT);
